var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M23.435 12.498c0 6.04-4.897 10.937-10.938 10.937-6.04 0-10.937-4.897-10.937-10.937 0-6.04 4.897-10.938 10.937-10.938 6.04 0 10.938 4.897 10.938 10.938zm-6.213-3.572c.092-.13 0-.31-.16-.31h-1.144a.78.78 0 0 0-.632.324l-3.838 5.323-1.739-2.413a.777.777 0 0 0-.632-.324H7.932a.196.196 0 0 0-.159.31l3.045 4.219a.776.776 0 0 0 1.262 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8354d67d35e4118af4aaf40cd435db5b.svg";
export { ForwardRef as ReactComponent };